
<div class="permission-management-page">

  <!-- LOADING: SOSTITUISCE L'INTERO CONTENUTO -->
  <div
    *ngIf="permissionsLoading"
    class="permission-loading"
    role="status"
    aria-live="polite"
  >
    <img
      src="assets/icons/loading-spinner.svg"
      alt="Caricamento permessi"
      class="permission-loading-image"
    />

    <span>Caricamento permessi in corso...</span>
  </div>

  <!-- CONTENUTO VISIBILE SOLTANTO A CARICAMENTO TERMINATO -->
  <p-scrollPanel
    *ngIf="!permissionsLoading"
    styleClass="permission-management-scroll"
    [style]="{ width: '100%', height: 'calc(100% - 32px)' }"
  >

    <div class="permission-management-content">

      <!-- RIEPILOGO GRAFICI -->

      <section class="permission-charts-section">

        <div class="permission-section-heading">
          <div class="permission-section-icon">
            <i class="pi pi-chart-pie"></i>
          </div>

          <div class="permission-section-heading-text">
            <h2>Riepilogo permessi</h2>
            <p>Situazione dei permessi sindacali e delle ore usufruite.</p>
          </div>
        </div>

        <div class="permission-charts-grid">

          <!-- ARTICOLO 27 -->

          <div class="permission-chart-card">

            <div class="permission-chart-header">
              <div class="permission-chart-icon">
                <i class="pi pi-chart-pie"></i>
              </div>

              <div class="permission-chart-heading">
                <h3>Articolo 27</h3>
                <span>Ore usufruite e rimanenti</span>
              </div>
            </div>

            <div class="permission-chart-body">
              <p-chart
                type="pie"
                [data]="art27Data"
              ></p-chart>
            </div>

          </div>

          <!-- ARTICOLO 30 -->

          <div class="permission-chart-card">

            <div class="permission-chart-header">
              <div class="permission-chart-icon">
                <i class="pi pi-chart-pie"></i>
              </div>

              <div class="permission-chart-heading">
                <h3>Articolo 30</h3>
                <span>Ore usufruite e rimanenti</span>
              </div>
            </div>

            <div class="permission-chart-body">
              <p-chart
                type="pie"
                [data]="art30Data"
              ></p-chart>
            </div>

          </div>

          <!-- PER PERSONA -->

          <div class="permission-chart-card">

            <div class="permission-chart-header">
              <div class="permission-chart-icon">
                <i class="pi pi-users"></i>
              </div>

              <div class="permission-chart-heading">
                <h3>Usufruito per persona</h3>
                <span>Distribuzione delle ore per delegato</span>
              </div>
            </div>

            <div class="permission-chart-body">
              <p-chart
                type="pie"
                [data]="personData"
              ></p-chart>
            </div>

          </div>

        </div>

      </section>

      <!-- MONTE ORE PERMESSI -->

      <section class="permission-table-card">

        <div class="permission-table-heading">

          <div class="permission-table-heading-left">
            <div class="permission-section-icon">
              <i class="pi pi-calendar"></i>
            </div>

            <div class="permission-section-heading-text">
              <h2>Monte ore permessi</h2>
              <p>Gestisci le ore disponibili e rimanenti per articolo.</p>
            </div>
          </div>

          <div class="permission-toolbar">

            <p-button
              label="Aggiorna"
              icon="pi pi-refresh"
              styleClass="permission-refresh-button"
              (onClick)="loadAll()"
            ></p-button>

            <p-button
              label="Aggiungi"
              icon="pi pi-plus"
              styleClass="permission-add-button"
              [disabled]="currentlyEditing !== null"
              (onClick)="createNewTotal()"
            ></p-button>

          </div>

        </div>

        <div class="permission-table-container">

          <p-table
            styleClass="p-datatable-sm permission-data-table"
            [value]="permissionTotals"
            [tableStyle]="{ 'min-width': '680px' }"
          >

            <ng-template pTemplate="header">
              <tr>
                <th>Azioni</th>
                <th>Anno</th>
                <th>Totale</th>
                <th>Rimanente</th>
                <th>Articolo</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-total>

              <!-- RIGA IN MODIFICA -->

              <tr
                *ngIf="currentlyEditing?.totalId === total.totalId"
                class="permission-editing-row"
              >

                <td>
                  <div class="permission-row-actions">

                    <p-button
                      icon="pi pi-save"
                      severity="success"
                      styleClass="permission-action-button"
                      (onClick)="modifyTotal()"
                    ></p-button>

                    <p-button
                      icon="pi pi-times"
                      severity="danger"
                      styleClass="permission-action-button"
                      (onClick)="editTotal(null)"
                    ></p-button>

                  </div>
                </td>

                <td>
                  <span class="permission-year">
                    {{ total.year }}
                  </span>
                </td>

                <td>
                  <p-inputNumber
                    locale="it-IT"
                    inputId="minmaxfraction"
                    mode="decimal"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    [(ngModel)]="total.total"
                  ></p-inputNumber>
                </td>

                <td>
                  <p-inputNumber
                    locale="it-IT"
                    inputId="minmaxfraction"
                    mode="decimal"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    [(ngModel)]="total.remaining"
                  ></p-inputNumber>
                </td>

                <td>
                  <p-selectButton
                    [allowEmpty]="false"
                    [options]="artOptions"
                    [(ngModel)]="total.article"
                  >
                    <ng-template let-item pTemplate>
                      {{ artOptionStrings[item] }}
                    </ng-template>
                  </p-selectButton>
                </td>

              </tr>

              <!-- RIGA NORMALE -->

              <tr *ngIf="currentlyEditing?.totalId !== total.totalId">

                <td>
                  <div class="permission-row-actions">

                    <p-button
                      icon="pi pi-pencil"
                      severity="warning"
                      styleClass="permission-action-button"
                      (onClick)="editTotal(total)"
                    ></p-button>

                    <p-button
                      icon="pi pi-trash"
                      severity="danger"
                      styleClass="permission-action-button"
                      (onClick)="removeTotal(total)"
                    ></p-button>

                  </div>
                </td>

                <td>
                  <span class="permission-year">
                    {{ total.year }}
                  </span>
                </td>

                <td>
                  <span class="permission-number">
                    {{ total.total }}
                  </span>
                </td>

                <td>
                  <span class="permission-number">
                    {{ total.remaining }}
                  </span>
                </td>

                <td>
                  <span class="permission-article-badge">
                    {{ artOptionStrings[total.article] }}
                  </span>
                </td>

              </tr>

            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5">
                  <div class="permission-empty-state">
                    <i class="pi pi-calendar-times"></i>
                    <strong>Nessun monte ore presente</strong>
                    <span>Non ci sono dati da visualizzare.</span>
                  </div>
                </td>
              </tr>
            </ng-template>

          </p-table>

        </div>

      </section>

      <!-- STORICO PERMESSI -->

      <section class="permission-table-card permission-history-card">

        <div class="permission-table-heading">

          <div class="permission-table-heading-left">
            <div class="permission-section-icon">
              <i class="pi pi-history"></i>
            </div>

            <div class="permission-section-heading-text">
              <h2>Storico permessi</h2>
              <p>Elenco dei permessi registrati e relativo stato di revoca.</p>
            </div>
          </div>

          <!-- AZIONI PRECEDENTEMENTE NEL MENU FLOTTANTE -->

          <div class="permission-toolbar">

            <p-button
              label="Nuovo permesso"
              icon="pi pi-plus-circle"
              styleClass="permission-add-button"
              (onClick)="openPermissionManagementDialog()"
            ></p-button>

            <p-button
              label="Revoca permesso"
              icon="pi pi-minus-circle"
              styleClass="permission-revoke-button"
              (onClick)="openPermissionRevokeDialog()"
            ></p-button>

          </div>

        </div>

        <div class="permission-table-container permission-history-container">

          <p-table
            styleClass="p-datatable-sm permission-data-table permission-history-table"
            [value]="visiblePermissions"
            [tableStyle]="{ 'min-width': '720px', 'width': '100%', 'table-layout': 'fixed' }"
          >

            <!-- Larghezze identiche in ogni pagina, indipendenti dai nomi -->
            <ng-template pTemplate="colgroup">
              <colgroup>
                <col style="width: 12%" />
                <col style="width: 25%" />
                <col style="width: 17%" />
                <col style="width: 10%" />
                <col style="width: 16%" />
                <col style="width: 20%" />
              </colgroup>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th>Azioni</th>
                <th>Delegato</th>
                <th>Data</th>
                <th>Ore</th>
                <th>Articolo</th>
                <th>Revocato</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-permission>
              <tr>

                <td>
                  <div class="permission-row-actions">

                    <p-button
                      icon="pi pi-trash"
                      severity="danger"
                      styleClass="permission-action-button"
                      (onClick)="removePermission(permission)"
                    ></p-button>

                  </div>
                </td>

                <td>
                  <span class="permission-delegate">
                    {{ permission.delegate.user.name }}
                    {{ permission.delegate.user.lastName }}
                  </span>
                </td>

                <td>
                  {{ permission.permissionDate | date: 'dd/MM/y' }}
                </td>

                <td>
                  <span class="permission-number">
                    {{ permission.totalTime }}
                  </span>
                </td>

                <td>
                  <span class="permission-article-badge">
                    {{ artOptionStrings[permission.article] }}
                  </span>
                </td>

                <td>
                  <p-tag
                    *ngIf="permission.revokeDate !== null && permission.revokeDate !== undefined"
                    severity="danger"
                    value="Sì"
                  ></p-tag>

                  <p-tag
                    *ngIf="permission.revokeDate === null || permission.revokeDate === undefined"
                    severity="success"
                    value="No"
                  ></p-tag>
                </td>

              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">
                  <div class="permission-empty-state">
                    <i class="pi pi-inbox"></i>
                    <strong>Nessun permesso presente</strong>
                    <span>Non ci sono permessi registrati da visualizzare.</span>
                  </div>
                </td>
              </tr>
            </ng-template>

          </p-table>

          <!-- PAGINAZIONE PERSONALIZZATA -->
          <div class="permission-history-footer">
            <button
              type="button"
              class="permission-page-button permission-page-prev"
              [disabled]="permissionPage === 0"
              (click)="previousPermissionPage()"
            >
              <i class="pi pi-chevron-left" aria-hidden="true"></i>
              <span>Precedente</span>
            </button>

            <span class="permission-page-report">
              {{ permissionPageStart }}–{{ permissionPageEnd }} / {{ permissions.length }}
            </span>

            <button
              type="button"
              class="permission-page-button permission-page-next"
              [disabled]="permissionPage >= permissionPageCount - 1"
              (click)="nextPermissionPage()"
            >
              <span>Successiva</span>
              <i class="pi pi-chevron-right" aria-hidden="true"></i>
            </button>
          </div>

        </div>

      </section>

    </div>

  </p-scrollPanel>

</div>
